import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { publishUpdate } from "./actions";

export function useSubscribe(channel, onNotify) {
  const update = useSelector(({ hubly }) => {
    return hubly.data.appMessages[channel];
  });

  React.useEffect(() => {
    onNotify(update);
  }, [update, onNotify]);
}

export function useNotify(events) {
  const dispatch = useDispatch();

  return React.useCallback(
    (value) => {
      dispatch(publishUpdate(events, value));
    },
    [dispatch, events]
  );
}
